import {Segmented} from "antd";
import {useEffect, useState} from "react";
import {SingleLayerSettingsColor} from "../singleLayer/SingleLayerSettingsColor";

export function SplitViewLayerSettingsColor({
                                                colorMaps,
                                                colorMapOneName,
                                                setColorMapOneName,
                                                colorMapOneOpacity,
                                                setColorMapOneOpacity,
                                                colorMapsTwo,
                                                colorMapTwoName,
                                                setColorMapTwoName,
                                                colorMapTwoOpacity,
                                                setColorMapTwoOpacity,
                                                dataOne,
                                                dataTwo
                                            }) {
    const [isRightView, setIsRightView] = useState(true)

    function onChangeView(value) {
        setIsRightView(value === 'Right')
    }

    return (
        <>
            <Segmented
                style={{
                    position: 'absolute',
                    top: 60,
                    right: 0,
                    left: 0,
                }}
                defaultValue="Right"
                options={["Left", "Right"]}
                onChange={onChangeView}
                block/>
            <div style={{height: 20}}></div>
            {!isRightView && <SingleLayerSettingsColor
                colorMaps={colorMaps}
                colorMapName={colorMapOneName}
                setColorMapName={setColorMapOneName}
                colorMapOpacity={colorMapOneOpacity}
                setColorMapOpacity={setColorMapOneOpacity}
                data={dataOne}
            ></SingleLayerSettingsColor>}
            {isRightView && <SingleLayerSettingsColor
                colorMaps={colorMapsTwo}
                colorMapName={colorMapTwoName}
                setColorMapName={setColorMapTwoName}
                colorMapOpacity={colorMapTwoOpacity}
                setColorMapOpacity={setColorMapTwoOpacity}
                data={dataTwo}
            ></SingleLayerSettingsColor>}
        </>
    )
}